// extracted by mini-css-extract-plugin
export var headerCss = "default-module--headerCss--i0yni";
export var titleCss = "default-module--titleCss--YtJ9N";